import { getCityInfo, getDeviceInfo } from './index';
import { ENV_MODE, REGION_MODE } from './config';
export async function initSdk(platform: string, customParams?: any) {
  return new Promise(async (resolve, reject) => {
    let sdkInstance: any = await import('sa-sdk-javascript');
    let config: any = {
      test: {
        us: 'https://datasink-bj.ninebot.com/web?token=d2ViOnU1bmlHamRMczRMd1BwOFY=',
        cn: 'https://datasink-bj.ninebot.com/web?token=d2ViOnU1bmlHamRMczRMd1BwOFY='
      },

      grey: {
        us: 'https://datasink-bj.ninebot.com/web?token=d2ViOnU1bmlHamRMczRMd1BwOFY=',
        cn: 'https://datasink-bj.ninebot.com/web?token=d2ViOnU1bmlHamRMczRMd1BwOFY='
      },
      prod: {
        us: 'https://datasink-fra.ninebot.com/web?token=d2ViOnU1bmlHamRMczRMd1BwOFY=',
        cn: 'https://datasink-bj.ninebot.com/web?token=d2ViOnU1bmlHamRMczRMd1BwOFY='
      }
    };
    sdkInstance.init({
      server_url: config[ENV_MODE][REGION_MODE],
      send_type: 'beacon',
      showLog: true,
      heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'default'
      },
      preset_properties: {
        latest_referrer: true,
        latest_referrer_host: true
      }
    });
    sdkInstance.quick('isReady', async function () {
      let anonymousID = sdkInstance.quick('getAnonymousID');
      const { country, province, city, ip } = await getCityInfo();
      const { browserName, browserVersion } = getDeviceInfo(); // 设备信息
      sdkInstance.registerPage({
        time: Date.now(),
        tracking_version: '1.0.1',
        platform,
        anonymous_id: anonymousID,
        _track_id: Math.random().toString(36).substr(3, 10),
        $country: country,
        $province: province,
        $city: city,
        $token: 'd2ViOnU1bmlHamRMczRMd1BwOFY=',
        $ip: ip,
        $browser: browserName,
        $browser_version: browserVersion,
        env: ENV_MODE == 'prod' ? 1 : 2,
        ...customParams
      });

      sdkInstance.quick('autoTrack');
      resolve(sdkInstance);
    });
  });
}
